export function VueRenderMixin(fields) {
  let watchers = {};
  for (var field of fields) {
    watchers[field] = function () {
      $(document).trigger("vue-render");
    };
  }

  return {
    watch: watchers,
    mounted: function () {
      $(document).trigger("vue-render");
    },
  };
}
